import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import {
	brandPrimary,
	brandPrimaryHover,
	charmGray,
	destructive,
	grayIconFill,
	gray4,
	navigation,
	success,
	warningDark,
	white,
} from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 20,
		padding: 16,
	},
	contentWrapper: {
		backgroundColor: white,
		borderRadius: 6,
		padding: 24,
		border: `1px solid ${charmGray}`,
		maxWidth: 1200,
		margin: '0 auto',
		width: '100%',
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		marginBottom: 24,
	},
	pageTitle: {
		color: THEME.colors.text.dark,
		fontSize: 24,
		fontWeight: 600,
		margin: 0,
	},
	statsContainer: {
		display: 'flex',
		gap: 32,
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	statItem: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	statLabel: {
		color: grayIconFill,
		fontSize: 12,
		fontWeight: 500,
		textTransform: 'uppercase',
	},
	statValue: {
		color: THEME.colors.text.dark,
		fontSize: 24,
		fontWeight: 700,
	},
	categorySection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0,
		marginBottom: 20,
	},
	categoryHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		padding: '20px 24px',
		backgroundColor: brandPrimary,
		borderRadius: 8,
		cursor: 'pointer',
		transition: 'background-color 0.2s',
		':hover': {
			backgroundColor: brandPrimaryHover,
		},
	},
	categoryHeaderExpanded: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},
	categoryInfo: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	categoryName: {
		color: white,
		fontSize: 20,
		fontWeight: 600,
	},
	categoryRoleBadge: {
		display: 'inline-block',
		padding: '4px 10px',
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
		borderRadius: 12,
		color: white,
		fontSize: 11,
		fontWeight: 600,
		textTransform: 'uppercase',
		letterSpacing: 0.5,
		marginLeft: 12,
	},
	categoryDescription: {
		color: 'rgba(255, 255, 255, 0.85)',
		fontSize: 14,
	},
	categoryStats: {
		display: 'flex',
		gap: 24,
		alignItems: 'center',
	},
	categoryStat: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		alignItems: 'flex-end',
	},
	categoryStatLabel: {
		color: 'rgba(255, 255, 255, 0.7)',
		fontSize: 11,
		textTransform: 'uppercase',
	},
	categoryStatValue: {
		color: white,
		fontSize: 18,
		fontWeight: 600,
	},
	skillAreasInCategory: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
		gap: 16,
		padding: '16px 20px 20px 20px',
		backgroundColor: '#f5f7fa',
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		border: `1px solid ${charmGray}`,
		borderTop: 'none',
	},
	skillAreaSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0,
	},
	skillAreaHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		padding: '16px 20px',
		backgroundColor: '#f5f7fa',
		borderRadius: 8,
		cursor: 'pointer',
		transition: 'background-color 0.2s',
		border: `1px solid ${charmGray}`,
		':hover': {
			backgroundColor: '#eef1f5',
		},
	},
	skillAreaHeaderExpanded: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		borderBottom: 'none',
	},
	expandIcon: {
		width: 16,
		height: 16,
		fill: THEME.colors.text.dark,
		transition: 'transform 0.2s',
	},
	expandIconRotated: {
		transform: 'rotate(180deg)',
	},
	skillAreaInfo: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	skillAreaName: {
		color: THEME.colors.text.dark,
		fontSize: 18,
		fontWeight: 600,
	},
	skillAreaDescription: {
		color: navigation,
		fontSize: 14,
	},
	skillAreaStats: {
		display: 'flex',
		gap: 24,
		alignItems: 'center',
	},
	skillAreaStat: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		alignItems: 'flex-end',
	},
	skillAreaStatLabel: {
		color: grayIconFill,
		fontSize: 11,
		textTransform: 'uppercase',
	},
	skillAreaStatValue: {
		color: THEME.colors.text.dark,
		fontSize: 16,
		fontWeight: 600,
	},
	scenariosContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		padding: '12px 20px 20px 20px',
		backgroundColor: '#fafbfc',
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		border: `1px solid ${charmGray}`,
		borderTop: 'none',
	},
	scenarioCard: {
		display: 'flex',
		alignItems: 'center',
		gap: 16,
		padding: 16,
		backgroundColor: white,
		borderRadius: 6,
		cursor: 'pointer',
		transition: 'background-color 0.2s, transform 0.1s, box-shadow 0.2s',
		border: `1px solid ${charmGray}`,
		':hover': {
			backgroundColor: '#f5f7fa',
			transform: 'translateY(-1px)',
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
		},
	},
	scenarioIcon: {
		width: 24,
		height: 24,
	},
	scenarioIconCompleted: {
		color: success,
	},
	scenarioIconNotAttempted: {
		color: gray4,
	},
	scenarioInfo: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	scenarioName: {
		color: THEME.colors.text.dark,
		fontSize: 16,
		fontWeight: 500,
	},
	scenarioMeta: {
		display: 'flex',
		gap: 16,
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	scenarioMetaItem: {
		color: navigation,
		fontSize: 13,
	},
	emptyState: {
		padding: 40,
		textAlign: 'center',
		color: grayIconFill,
		fontSize: 14,
	},
	modalBackdrop: {
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
	},
	modalPopup: {
		backgroundColor: white,
		borderRadius: 12,
		maxWidth: 800,
		width: '90%',
		maxHeight: '90vh',
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
		border: `1px solid ${charmGray}`,
	},
	modalHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: 24,
		borderBottom: `1px solid ${charmGray}`,
	},
	modalHeaderInfo: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	modalTitle: {
		color: THEME.colors.text.dark,
		fontSize: 24,
		fontWeight: 600,
		margin: 0,
	},
	modalDescription: {
		color: navigation,
		fontSize: 14,
		margin: 0,
	},
	modalCloseButton: {
		cursor: 'pointer',
		padding: 8,
		borderRadius: 4,
		border: 'none',
		backgroundColor: 'transparent',
		color: grayIconFill,
		transition: 'background-color 0.2s',
		':hover': {
			backgroundColor: '#f5f7fa',
		},
	},
	modalBody: {
		padding: 24,
		overflowY: 'auto',
		flex: 1,
	},
	modalStatsRow: {
		display: 'flex',
		gap: 24,
		alignItems: 'center',
		marginBottom: 24,
		flexWrap: 'wrap',
	},
	modalStat: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	modalStatLabel: {
		color: grayIconFill,
		fontSize: 12,
		textTransform: 'uppercase',
		fontWeight: 500,
	},
	modalStatValue: {
		color: THEME.colors.text.dark,
		fontSize: 20,
		fontWeight: 600,
	},
	modalPracticeButton: {
		padding: '10px 20px',
		backgroundColor: brandPrimary,
		color: white,
		border: 'none',
		borderRadius: 6,
		fontSize: 14,
		fontWeight: 600,
		cursor: 'pointer',
		transition: 'background-color 0.2s',
		':hover': {
			backgroundColor: brandPrimaryHover,
		},
	},
	historySection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},
	historySectionTitle: {
		color: THEME.colors.text.dark,
		fontSize: 16,
		fontWeight: 600,
		marginBottom: 8,
	},
	historyTable: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	historyRow: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		padding: 16,
		backgroundColor: '#f5f7fa',
		borderRadius: 6,
		cursor: 'pointer',
		transition: 'background-color 0.2s',
		border: `1px solid ${charmGray}`,
		':hover': {
			backgroundColor: '#eef1f5',
		},
	},
	historyRowMain: {
		display: 'flex',
		alignItems: 'center',
		gap: 16,
	},
	historyDate: {
		color: THEME.colors.text.dark,
		fontSize: 14,
		fontWeight: 500,
		minWidth: 120,
	},
	historyScore: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	historyStatus: {
		color: success,
		fontSize: 14,
		flex: 1,
	},
	historyStatusFailed: {
		color: destructive,
	},
	historyStatusPending: {
		color: warningDark,
	},
	historyExpandIcon: {
		width: 16,
		height: 16,
		fill: grayIconFill,
		transition: 'transform 0.2s',
	},
	historyExpandIconRotated: {
		transform: 'rotate(180deg)',
	},
	historyNotes: {
		padding: 16,
		backgroundColor: white,
		borderRadius: 4,
		border: `1px solid ${charmGray}`,
		color: navigation,
		fontSize: 14,
		lineHeight: 1.6,
		whiteSpace: 'pre-wrap',
	},
	noHistoryMessage: {
		padding: 24,
		textAlign: 'center',
		color: grayIconFill,
		fontSize: 14,
	},
	historyScoreNA: {
		color: grayIconFill,
	},
	loading: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: 40,
		color: grayIconFill,
		fontSize: 16,
	},
	error: {
		padding: 24,
		backgroundColor: 'rgba(208, 2, 27, 0.1)',
		borderRadius: 6,
		color: destructive,
		fontSize: 14,
	},
});
